import * as $ from "jquery";

function initAlerts() {
	$('.js-close-alert').on('click', function() {
		$(this).closest('.alert').fadeOut().remove();
	});
}

export function init() {
	initAlerts();
}




// WEBPACK FOOTER //
// ./js/PFF/modules/alerts.ts